module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"FormEmail":{"personal":"Pessoal","professional":"Profissional"}},"en":{"FormEmail":{"personal":"Pessoal","professional":"Professional"}}}')
  delete Component.options._Ctor
}
